import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Role } from '../domain/models';
import { canAccessRole, hasRequiredConsent, isSessionActive } from '../domain/auth';
import { useAppStore } from '../store/AppStore';
import { AppFrame, PrimaryButton } from './ui';

export function RoleGuard({ allowed, requireConsent = true, children }: PropsWithChildren<{ allowed: Role[]; requireConsent?: boolean }>) {
  const { state, loading } = useAppStore();
  const location = useLocation();
  if (!state) return <AppFrame><div className="loading-screen">권한을 확인하고 있어요…</div></AppFrame>;
  if (!isSessionActive(state.session)) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!canAccessRole(state.session.role, allowed)) return <AccessDenied allowed={allowed} />;
  if (requireConsent && state.session.role === 'parent' && !hasRequiredConsent(state)) return <Navigate to="/consent" replace />;
  return <>{children}</>;
}

function AccessDenied({ allowed }: { allowed: Role[] }) {
  const { logout } = useAppStore();
  return <AppFrame><div className="system-state"><strong>접근 권한이 없습니다</strong><p>이 화면은 {allowed.join(' 또는 ')} 역할만 사용할 수 있습니다.</p><PrimaryButton onClick={() => void logout()}>다른 계정으로 로그인</PrimaryButton></div></AppFrame>;
}
